export { DMS_MODULE } from '../constants';
export const NAME = 'RevenueDetails';
export const API_NAME = 'RevenueDetails';
export const CRUMB_LABEL_KEY = 'RevenueDetails';
export const EMPTY_FILE_NAME = '';

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
export const PART_SALES_ORDER_TYPE = 'B';
